import { useState } from "react"

export const ColumnSortTrigger = ({ onClick, currentSortBy, sortBy, label }) => {
    const [direction, setDirection] = useState(0);

    const handleClick = () => {
        let newDirection;

        if (sortBy === currentSortBy) {
            // i.e. we are clicking in the same column as before then just change the direction
            newDirection = direction === 0 ? 1 : 0;
        }
        else {
            // we are changing the column - default direction to zero
            newDirection = 0;
        }
        onClick(newDirection)

        setDirection(newDirection)
    }
    return (
        <div role="button" onClick={ () => handleClick() } className='d-flex align-items-center gap-2'>
            { label }
            <div className="d-flex flex-column">
                {
                    currentSortBy !== sortBy ?
                        <>
                            <i className="fi-chevron-up fs--2 m-0 fs-xxs"></i>
                            <i className="fi-chevron-down fs-xxs m-0"></i>
                        </>
                        : <i className={ `fi-chevron-${ direction === 1 ? "up" : "down" } fs-xxs m-0` }></i>
                }
            </div>
        </div>
    )
}